/**
 * GA4 Tracker - Route-based event firing
 * Detects route via ga4-route.js, fetches data when needed, fires page_view, session_start, time_30s
 */

(function () {
  const gtag = window.trovelle?.ga4?.gtag;
  const measurementId = window.trovelle?.ga4?.measurementId;
  if (!gtag || !measurementId) return;

  const routeUtil = window.trovelle?.ga4?.route;
  if (!routeUtil) return;

  const route = routeUtil.getRoute();

  function parsePrice(val) {
    const n = typeof val === 'string' ? parseFloat(val) : Number(val);
    return isNaN(n) ? 0 : n;
  }

  function buildProductAttributes(product) {
    if (!product) return null;
    const v = product.selected_or_first_available_variant || product.variants?.[0];
    const price = parsePrice(v?.price ?? product.price);
    const color = product.metafields?.custom?.color?.value ?? v?.option1 ?? '';
    const fit = product.metafields?.custom?.fit?.value ?? product.metafields?.shopify?.fit?.value ?? '';
    const composition = product.metafields?.custom?.composition?.value ?? product.metafields?.shopify?.composition?.value ?? '';

    return {
      product_id: String(product.id),
      title: product.title || '',
      vendor_id: product.vendor || '',
      vendor_name: product.vendor || '',
      sku_id: v?.sku || '',
      product_type: product.product_type || product.type || '',
      price,
      color,
      fit,
      composition,
    };
  }

  function sendPageView(params) {
    gtag('event', 'page_view', {
      page_location: params.page_location || window.location.href,
      page_title: params.page_title || document.title,
      referrer: document.referrer || '',
      page_type: params.page_type || route.pageType,
      result_count: params.result_count ?? undefined,
      product_attributes: params.product_attributes ?? undefined,
    });
  }

  function sendSessionStart() {
    if (sessionStorage.getItem('ga4_session_started')) return;
    sessionStorage.setItem('ga4_session_started', '1');
    const u = new URL(window.location.href);
    gtag('event', 'session_start', {
      source: u.searchParams.get('utm_source') || '',
      medium: u.searchParams.get('utm_medium') || '',
      campaign: u.searchParams.get('utm_campaign') || '',
      landing_page: window.location.href,
    });
  }

  function sendTime30s() {
    const key = 'ga4_time30s_' + window.location.pathname;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    gtag('event', 'time_30s', {
      page_location: window.location.href,
      page_type: route.pageType,
    });
  }

  function startTime30sTimer() {
    let activeSeconds = 0;
    const tick = () => {
      if (document.visibilityState === 'visible') {
        activeSeconds += 1;
        if (activeSeconds >= 30) {
          sendTime30s();
          clearInterval(iv);
        }
      }
    };
    const iv = setInterval(tick, 1000);
  }

  async function handleProduct() {
    if (!route.handle) {
      sendPageView({});
      return;
    }
    try {
      const res = await fetch('/products/' + route.handle + '.json');
      const json = await res.json();
      const product = json?.product;
      const attrs = buildProductAttributes(product);
      sendPageView({ product_attributes: attrs });
      if (product) {
        const v = product.selected_or_first_available_variant || product.variants?.[0];
        const price = parsePrice(v?.price ?? product.price);
        gtag('event', 'view_item', {
          currency: window.trovelle?.shop?.currency || 'USD',
          value: price,
          items: [{
            item_id: String(product.id),
            item_name: product.title || '',
            item_brand: product.vendor || undefined,
            item_category: product.product_type || product.type || undefined,
            item_variant: v?.title || undefined,
            price,
            quantity: 1,
          }],
        });
      }
    } catch {
      sendPageView({});
    }
  }

  async function handleCollection() {
    let resultCount = null;
    if (route.handle) {
      try {
        const res = await fetch('/collections/' + route.handle + '.json');
        const json = await res.json();
        resultCount = json?.collection?.products_count ?? null;
      } catch {}
    }
    sendPageView({ result_count: resultCount });
  }

  function handleSearch() {
    let resultCount = null;
    const el = document.querySelector('.facets, .facet, [aria-label*="result"]');
    if (el) {
      const m = el.textContent?.match(/(\d+)/);
      if (m) resultCount = parseInt(m[1], 10);
    }
    sendPageView({ result_count: resultCount });
  }

  function handleIndex() {
    sendPageView({});
  }

  function handleBrands() {
    sendPageView({});
  }

  function handlePage() {
    sendPageView({});
  }

  function handleCart() {
    sendPageView({});
  }

  const handlers = {
    product: handleProduct,
    collection: handleCollection,
    search: handleSearch,
    index: handleIndex,
    brands: handleBrands,
    page: handlePage,
    cart: handleCart,
  };

  async function init() {
    sendSessionStart();
    const handler = handlers[route.type] || handlePage;
    await handler();
    startTime30sTimer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
